export enum CalendarState {
  positive = 'positive',
  negative = 'negative',
  close = 'close',
  missingReport = 'missingReport'
}
